<template>
  <div>
    <ion-img class="img" src="/assets/image/hear-2.png"></ion-img>
  </div>
</template>

<script>
import {IonImg} from "@ionic/vue";

export default {
  name: "TestHearStop",
  components: {
    IonImg
  }
}
</script>

<style scoped>

</style>